import { SovosMenuItem, SovosSelect } from "mosaic-react";
import React from "react";
import { FIELD_SPACING_SX } from "./constants";

const LegalStructureField = ({ disabled, i18n, onChange, structures, value }) => (
    <SovosSelect
        disabled={disabled}
        displayEmpty
        fullWidth
        label={i18n`Legal structure`}
        onChange={(event) => onChange(event.target.value)}
        sx={FIELD_SPACING_SX}
        value={value || ""}
    >
        <SovosMenuItem disabled value="">
            {i18n`Select legal structure`}
        </SovosMenuItem>
        {structures.map((structure) => (
            <SovosMenuItem key={structure.id} value={structure.id}>
                {structure.label}
            </SovosMenuItem>
        ))}
    </SovosSelect>
);

export default LegalStructureField;
